import axios from "axios";
import { keycloak } from "../../../lib/keycloak/index.ts";
import { DocumentDTO, DocumentF24StatusUpdateDTO, DocumentFilters, DocumentReportDTO, FindAllDocumentsResponseDTO, FindExtensionsFileRequestDTO, FindExtensionsFileResponseDTO } from "./dto.ts";
import { DocumentService } from "./service.ts";

export class DocumentServiceImpl implements DocumentService {

    public findAllDocuments(filters: DocumentFilters): Promise<FindAllDocumentsResponseDTO> {
        
        let url: string = "/api/documents?page=" + filters.page +
            "&itemsPerPage=" + filters.itemsPerPage +
            "&order=" + filters.order +
            (filters.companyId !== null ? "&companyId=" + filters.companyId : '') +
            (filters.referenceMonth !== 0 ? ("&referenceMonth=" + filters.referenceMonth) : '') +
            (filters.referenceYear !== 0 ? ("&referenceYear=" + filters.referenceYear) : '') +
            (filters.senderGroup !== "" ? ("&senderGroup=" + filters.senderGroup) : '') +
            (filters.sort !== "" ? ("&sort=" + filters.sort) : '') +
            (filters.type !== "" ? ("&type=" + filters.type) : '') +
            (filters.typology !== "" ? ("&typology=" + filters.typology) : '') +
            (filters.fileName !== "" ? ("&fileName=" + filters.fileName) : '') +
            (filters.receiverGroup !== '' ? ("&receiverGroup=" + filters.receiverGroup) : '') +
            (filters.status !== "" ? ("&status=" + filters.status) : '') +
            (filters.f24Status !== "" && filters.f24Status ? ("&f24Status=" + filters.f24Status) : '')
        return axios({
            url: url,
            method: "GET",
            headers: {
                Authorization: 'Bearer ' + keycloak.token,
                Accept: '*/*',
                ContentType: 'application/json',
                "Access-Control-Allow-Headers": "accept, authorization, content-type, x-requested-with",
                "Access-Control-Allow-Origin": "http://localhost:3000",
                "Access-Control-Allow-Methods": "GET",
            }
        }).then((response) => response.data)
    }

    public findByIdDocument(id: string): Promise<DocumentDTO> {
        let url: string = "/api/documents/" + id
        return axios({
            url: url,
            method: "GET",
            headers: {
                Authorization: 'Bearer ' + keycloak.token,
                Accept: '*/*',
                ContentType: 'application/json',
                "Access-Control-Allow-Headers": "accept, authorization, content-type, x-requested-with",
                "Access-Control-Allow-Origin": "http://localhost:3000",
                "Access-Control-Allow-Methods": "GET",
            }
        }).then((response) => response.data)
    }

    public saveDocument(form: FormData): Promise<string> {
        let url: string = "/api/documents"
        return axios({
            url: url,
            method: "POST",
            data: form,
            headers: {
                Authorization: 'Bearer ' + keycloak.token,
                Accept: '*/*',
                ContentType: 'application/json',
                "Access-Control-Allow-Headers": "accept, authorization, content-type, x-requested-with",
                "Access-Control-Allow-Origin": "http://localhost:3000",
                "Access-Control-Allow-Methods": "GET",
            }
        }).then((response) => response.data)
    }

    public deleteDocument(id: string): Promise<void> {
        let url: string = "/api/documents/" + id
        return axios({
            url: url,
            method: "DELETE",
            headers: {
                Authorization: 'Bearer ' + keycloak.token,
                Accept: '*/*',
                ContentType: 'application/json',
                "Access-Control-Allow-Headers": "accept, authorization, content-type, x-requested-with",
                "Access-Control-Allow-Origin": "http://localhost:3000",
                "Access-Control-Allow-Methods": "GET",
            }
        }).then(() => undefined)
    }

    public documentReport(id: string): Promise<DocumentReportDTO> {
        let url: string = "/api/documents/report/" + id
        return axios({
            url: url,
            method: "GET",
            headers: {
                Authorization: 'Bearer ' + keycloak.token,
                Accept: '*/*',
                ContentType: 'application/json',
                "Access-Control-Allow-Headers": "accept, authorization, content-type, x-requested-with",
                "Access-Control-Allow-Origin": "http://localhost:3000",
                "Access-Control-Allow-Methods": "GET",
            }
        }).then((response) => response.data)
    }

    public updateStatusF24(id: string, data: DocumentF24StatusUpdateDTO): Promise<void> {
        let url: string = "/api/documents/" + id + "/f24"
        return axios({
            url: url,
            method: "PUT",
            data: data,
            headers: {
                Authorization: 'Bearer ' + keycloak.token,
                Accept: '*/*',
                ContentType: 'application/json',
                "Access-Control-Allow-Headers": "accept, authorization, content-type, x-requested-with",
                "Access-Control-Allow-Origin": "http://localhost:3000",
                "Access-Control-Allow-Methods": "GET",
            }
        }).then((response) => response.data)
    }

    public findExtensionsFiles(request: FindExtensionsFileRequestDTO): Promise<FindExtensionsFileResponseDTO> {
        let url: string = "/api/object-storage/find-extension-files?" + request.ids.map(item => ('request=' + item)).join('&')
        
        return axios({
            url: url,
            method: "GET",
            data: request,
            headers: {
                Authorization: 'Bearer ' + keycloak.token,
                Accept: '*/*',
                ContentType: 'application/json',
                "Access-Control-Allow-Headers": "accept, authorization, content-type, x-requested-with",
                "Access-Control-Allow-Origin": "http://localhost:3000",
                "Access-Control-Allow-Methods": "GET",
            }
        }).then((response) => response.data)
    }
}
